import { render } from "./SizingContent.vue?vue&type=template&id=3784320d"
import script from "./SizingContent.vue?vue&type=script&lang=js"
export * from "./SizingContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__